export default "__VITE_ASSET__CymrHtr5__"